'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagToAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 4.50781e-06C8.66667 -9.72733e-07 19.3333 8.13479e-08 28 8.13479e-08C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V4.50781e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 8.13479e-08L16 3.94157e-06V10.6667H0V20H28V8.13479e-08Z",
          fill: "#E20F1B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7 1.33334C6.81591 1.33334 6.66667 1.48258 6.66667 1.66667V4H4.33333C4.14924 4 4 4.14924 4 4.33334V6.33334C4 6.51743 4.14924 6.66667 4.33333 6.66667H6.66667V9C6.66667 9.1841 6.81591 9.33334 7 9.33334H9C9.1841 9.33334 9.33333 9.1841 9.33333 9V6.66667H11.6667C11.8508 6.66667 12 6.51743 12 6.33334V4.33334C12 4.14924 11.8508 4 11.6667 4H9.33333V1.66667C9.33333 1.48258 9.1841 1.33334 9 1.33334H7Z",
          fill: "#DF101B"
        }
      )
    ]
  }
);
const VpFlagToAsset = forwardRef(FlagToAsset);

export { VpFlagToAsset as default };
